<template>
  <div class="tile tile--user">
    <p v-if="!editing" class="text__bold text__center">{{ user.name }}</p>
    <input v-else type="text" name="name" v-model="form.name" class="text__center text__bold" />
    <p class="grid__between">
      <span class="text__bold email__overflow">Email:</span>
      <span v-if="!editing" class="text__overflow">{{ user.email }}</span>
      <input v-else type="email" v-model="form.email" class="user__width" />
    </p>
    <p class="grid__between">
      <span class="text__bold">Is Active:</span>
      <span v-if="!editing">{{ user.isActive ? "active" : "inactive" }}</span>
      <select v-else v-model="form.isActive" class="user__width">
        <option :value="true">active</option>
        <option :value="false">inactive</option>
      </select>
    </p>
    <p class="grid__between">
      <span class="text__bold">Is Admin:</span>
      <span v-if="!editing">{{ user.isAdmin ? "admin" : "not admin" }}</span>
      <select v-else v-model="form.isAdmin" class="user__width">
        <option :value="true">admin</option>
        <option :value="false">not admin</option>
      </select>
    </p>
    <p v-if="!editing" class="flex__between">
      <button class="btn btn__small btn__red" @click="toggleDelete">Delete</button>
      <button v-if="!editing" class="btn btn__small btn__green" @click="toggleEditing">Edit</button>
    </p>
    <p v-else class="flex__between">
      <button class="btn btn__small btn__red" @click="toggleEditing">Cancel</button>
      <button class="btn btn__small btn__green" @click="updateUser">Done</button>
    </p>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { VALID_DOMAINS, isValidDomain } from "../../../firebase/auth";

export default {
  props: ["user"],
  data() {
    return {
      editing: false,
      form: {
        _id: this.user ? this.user._id : null,
        name: this.user ? this.user.name : null,
        email: this.user ? this.user.email : null,
        isActive: this.user ? this.user.isActive : null,
        isAdmin: this.user ? this.user.isAdmin : null
      },
      reset: {
        _id: this.user ? this.user._id : null,
        name: this.user ? this.user.name : null,
        email: this.user ? this.user.email : null,
        isActive: this.user ? this.user.isActive : null,
        isAdmin: this.user ? this.user.isAdmin : null
      }
    };
  },
  methods: {
    ...mapActions(["startUpdateUser"]),
    toggleDelete() {
      this.$emit("toggleDelete", this.user);
    },
    toggleEditing() {
      return (this.editing = !this.editing);
    },
    async updateUser() {
      const re = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      if (this.form.name.trim() === "") {
        return this.flash("Update error: Name cannot be blank", "error");
      }
      if (this.form.email.trim() === "") {
        return this.flash("Update error: email cannot be blank", "error");
      }
      if (!re.test(this.form.email)) {
        return this.flash(
          "Update error: you must enter a valid email",
          "error"
        );
      }
      if (!isValidDomain(this.form.email)) {
        return this.flash(
          `Update error: only ${VALID_DOMAINS.join(", ")} domains permitted`,
          "error"
        );
      }
      try {
        await this.startUpdateUser(this.form);
        this.toggleEditing();
      } catch (err) {
        this.form = this.reset;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.email__overflow {
  overflow: hidden;
}
.text__overflow {
  max-width: 180px;
}
.tile--user {
  margin: 15px 0;
  @include grid($rows: 50px 45px 45px 45px 50px, $row-gap: 5px);
  input,
  select {
    width: 100%;
  }
}
.grid__between {
  @include grid($cols: 80px 1fr, $col-gap: 10px, $align: center);
  :nth-child(2) {
    text-align: right;
    text-align-last: right;
    margin-left: auto;
  }
}
@media (min-width: $sm) {
  .text__overflow {
    max-width: 125px;
  }
}
@media (min-width: $md) {
  .text__overflow {
    max-width: 150px;
  }
}
@media (min-width: $xl) {
  .text__overflow {
    max-width: 125px;
  }
}
@media (min-width: $xxl) {
  .text__overflow {
    max-width: 150px;
  }
}
</style>